import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import DependenciesLoader from './dependencies-loader'

import Theme from '../../shared/theme'
import Routes from './routes'

const Root: React.FC = React.memo(function Root() {
    return (
        <Theme>
            <DependenciesLoader>
                <BrowserRouter>
                    <Routes />
                </BrowserRouter>
            </DependenciesLoader>
        </Theme>
    )
})

export default Root
